/** خطای خلاصه job / alert — مثل «HTTP 429 — ناموفق — …» (بدون ترجمه؛ بک‌اند msg فارسی می‌فرستد). */
export function formatIndexerErrorLine(input: {
  httpStatus?: number | null;
  statusLabel?: string | null;
  message?: string | null;
}): string | null {
  const parts: string[] = [];
  if (input.httpStatus != null) parts.push(`HTTP ${input.httpStatus}`);
  if (input.statusLabel?.trim()) parts.push(input.statusLabel.trim());
  if (input.message?.trim()) parts.push(input.message.trim());
  return parts.length > 0 ? parts.join(' — ') : null;
}
